import React from "react";
import { Apple, Smartphone, Sparkles, Share } from "lucide-react";

/**
 * "Get the app" card — CalenLingo is a Progressive Web App, so it installs
 * to the home screen on both iOS Safari and Android Chrome. This card gives
 * clear one-tap-style instructions per platform.
 */
export default function GetAppCard() {
  return (
    <div className="bg-card border-2 border-honey/40 rounded-2xl p-6 space-y-4" data-testid="get-app-card">
      <div className="flex items-center gap-2 text-sm uppercase tracking-widest text-muted-foreground">
        <Sparkles className="w-4 h-4 text-honey" strokeWidth={2} /> Take it with you
      </div>
      <div className="font-display text-2xl leading-tight tracking-tight">
        Install <span className="text-honey">CalenLingo</span> on your phone.
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">
        Works offline for today&rsquo;s word and lives on your home screen — no App Store required.
      </p>

      <div className="space-y-3">
        <div
          className="flex items-start gap-3 rounded-xl bg-muted p-3"
          data-testid="ios-install-steps"
        >
          <Apple className="w-5 h-5 text-foreground shrink-0 mt-0.5" strokeWidth={1.5} />
          <div className="text-sm leading-relaxed">
            <div className="font-medium">iPhone &amp; iPad</div>
            <div className="text-muted-foreground text-xs">
              Open in Safari &rarr; tap <Share className="w-3.5 h-3.5 inline align-text-bottom" /> Share &rarr; &ldquo;Add to Home Screen&rdquo;.
            </div>
          </div>
        </div>

        <div
          className="flex items-start gap-3 rounded-xl bg-muted p-3"
          data-testid="android-install-steps"
        >
          <Smartphone className="w-5 h-5 text-foreground shrink-0 mt-0.5" strokeWidth={1.5} />
          <div className="text-sm leading-relaxed">
            <div className="font-medium">Android</div>
            <div className="text-muted-foreground text-xs">
              Open in Chrome &rarr; menu (&#8942;) &rarr; &ldquo;Install app&rdquo; or &ldquo;Add to Home screen&rdquo;.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
